const RUN_CONFIGURATION_KEY_ROOT = "selectedRunConfigurationId";

export function getLocalStorageRunConfigurationKey(projectId: number): string {
  return `${RUN_CONFIGURATION_KEY_ROOT}:${projectId}`;
}

export function removeLocalStorageRunConfigurationIds(): void {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith(RUN_CONFIGURATION_KEY_ROOT)) {
      localStorage.removeItem(key);
      i--;
    }
  }
}

export function removeLocalStorageRunConfigurationById(projectId: number): void {
  localStorage.removeItem(`${RUN_CONFIGURATION_KEY_ROOT}:${projectId}`);
}
